export function hostnameMatchesDomainList(
  hostname: string,
  domains: readonly string[]
): boolean {
  if (domains.length === 0) {
    return false;
  }

  const normalized = hostname.toLowerCase();

  return domains.some((domain) => {
    const normalizedDomain = domain.toLowerCase();

    return (
      normalized === normalizedDomain ||
      normalized.endsWith(`.${normalizedDomain}`)
    );
  });
}
